import { PoFormField } from '../../../constants/constants';

export const getClassificationFieldName = (
  currentFieldName: string,
  fieldName: PoFormField
) => {
  const productFieldPrefix = currentFieldName.match(/^products\[\d+\]\./)?.[0];

  return productFieldPrefix ? `${productFieldPrefix}${fieldName}` : fieldName;
};
